import script from "./AddProjectlog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddProjectlog.vue?vue&type=script&lang=ts&setup=true"

import "./AddProjectlog.vue?vue&type=style&index=0&id=ed376664&lang=css"

const __exports__ = script;

export default __exports__